import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import styles from "./CardFooter.module.scss";

export default function CardFooter(props) {
  const { className, children, plain, profile, pricing, testimonial, ...rest } =
    props;
  const cardFooterClasses = classNames(
    styles.cardFooter,
    {
      [styles.cardFooterPlain]: plain,
      [styles.cardFooterProfile]: profile || testimonial,
      [styles.cardFooterPricing]: pricing,
      [styles.cardFooterTestimonial]: testimonial
    },
    className
  );
  return (
    <div className={cardFooterClasses} {...rest}>
      {children}
    </div>
  );
}

CardFooter.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  pricing: PropTypes.bool,
  testimonial: PropTypes.bool,
  children: PropTypes.node
};
